module.exports = {render: function () {with(this){return _c('svg',{attrs:{"id":"Livello_1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 13.9"}},[_c('path',{staticClass:"st0",attrs:{"d":"M1 13L13 1M1 1l12 12"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close_button.svg
// module id = 952
// module chunks = 1